/*
 * @Description: 按需引入 ECharts 图表和组件
 * @Author: mdb
 * @Date: 2022-11-24 14:28:25
 * @LastEditTime: 2022-11-24 16:29:34
 * @LastEditors: mdb
 */
// 引入 echarts 核心模块，核心模块提供了 echarts 使用必须要的接口
import * as echarts from 'echarts/core'
// 引入柱状图图表，图表后缀都为 Chart（系列类型的定义后缀都为 SeriesOption）
import { BarChart, BarSeriesOption, LineChart, GaugeChart, LineSeriesOption, PieChart, PieSeriesOption } from 'echarts/charts'
// 引入提示框，标题，直角坐标系，数据集，内置数据转换器等组件，组件后缀都为 Component（组件类型的定义后缀都为 ComponentOption）
import { TooltipComponent, TooltipComponentOption, LegendComponent, LegendComponentOption } from 'echarts/components'
// 标签自动布局，全局过渡动画等特性
import { LabelLayout, UniversalTransition } from 'echarts/features'
// 引入 SVGRenderer 渲染器s
import { SVGRenderer } from 'echarts/renderers'

// 通过 ComposeOption 来组合出一个只有必须组件和图表的 Option 类型
export type ECOption = echarts.ComposeOption<
  BarSeriesOption | LineSeriesOption | PieSeriesOption | TooltipComponentOption | LegendComponentOption
>

// 注册组件
echarts.use([
  BarChart,
  LineChart,
  PieChart,
  GaugeChart,
  TooltipComponent,
  LegendComponent,
  LabelLayout,
  UniversalTransition,
  SVGRenderer
])

export default echarts
